import { OnboardingFlow } from '@/components/onboarding/OnboardingFlow';
import SEO from '@/components/SEO';
import { Link } from 'react-router-dom';
import faceFableLogo from '@/assets/facefable-logo.png';

export default function Onboarding() {
  return (
    <>
      <SEO 
        title="Welcome to FaceFable™"
        description="Begin your personalised skincare journey with AI-powered analysis and dermatology-based insights."
      />
      
      {/* Simple Header with Logo Only */}
      <div className="w-full sticky top-0 z-50 bg-white">
        <div className="bg-white shadow-sm border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between">
            <div className="flex items-center">
              <img src={faceFableLogo} alt="FaceFable™" className="h-8" />
            </div>
          </div>
        </div>
      </div>

      <OnboardingFlow />
    </>
  );
}
